import { AppsIcon } from '@nimbus-ds/icons';
import { MenuButton } from '@nimbus-ds/patterns';
import { Link, useLocation } from 'react-router-dom';
import { useHandleMenuClick } from 'App/hooks';
import { useNuvemApps } from 'domains/PartnersApps/pages/NuvemAppPage/hooks';
import { menuPrimaryPinterestClick } from './tracking';

const PINTEREST_APP_ID = '13154';
const PINTEREST_APP_CODE = 'pinterest';
const BASE_PATH = `/apps/${PINTEREST_APP_ID}`;

function PinterestMenu() {
  const { pathname } = useLocation();
  const { handleClickItem } = useHandleMenuClick();
  const { nuvemApps } = useNuvemApps();
  const isPinterestInstalled = nuvemApps?.[PINTEREST_APP_CODE]?.installed;

  return (
    <MenuButton
      as={Link}
      to={`${BASE_PATH}${isPinterestInstalled ? '' : '/authorize'}`}
      startIcon={AppsIcon}
      onClick={() => {
        menuPrimaryPinterestClick(Boolean(isPinterestInstalled));
        handleClickItem();
      }}
      active={pathname.includes(BASE_PATH)}
      label="Pinterest"
    />
  );
}

export default PinterestMenu;
